import { IDropdown } from 'types/common/select'

export enum ProfileMenuLabels {
  ACCOUNT = 'My Account',
  SETTINGS = 'Settings',
  SUPPORT = 'Support',
  LOCK = 'Lock Screen'
}

export const profileMenus = [
  {
    label: ProfileMenuLabels.ACCOUNT,
    icon: 'uil uil-user'
  }
  // TODO: Integrate later
  // {
  //   label: ProfileMenuLabels.SETTINGS,
  //   icon: 'uil uil-cog',
  //   redirectTo: '/'
  // },
  // {
  //   label: ProfileMenuLabels.SUPPORT,
  //   icon: 'uil uil-life-ring',
  //   redirectTo: '/'
  // },
  // {
  //   label: ProfileMenuLabels.LOCK,
  //   icon: 'uil uil-lock-alt',
  //   redirectTo: '/'
  // }
]

export const blackAlpha700 = '#5C5C5C'

export const searchSortByOptions: IDropdown[] = [
  { title: 'Last updated', value: 'Last updated' },
  { title: 'Most viewed', value: 'Most viewed' },
  { title: 'Most relevant', value: 'Most relevant' },
  { title: 'Newest', value: 'Newest' },
  { title: 'Name (A-Z)', value: 'Name (A-Z)' }
]
